import { render, staticRenderFns } from "./Apartment.vue?vue&type=template&id=8aa3e85a"
import script from "./Apartment.vue?vue&type=script&lang=ts"
export * from "./Apartment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports